import type {
  OrganizationAPI,
  RequestParams,
  RestService,
  RestServiceConfig,
  TranslateAPI,
  UserAPI,
  UserPreferencesAPI,
} from '@sydle/ui-api';
import { DefaultRestService, defineAPIs, getAPI, setAPI } from '@sydle/ui-api';
import { BookmarkAPI } from '../../api/bookmark-api';
import { DraftAPI } from '../../api/draft-api';
import { FileAPI } from '../../api/file-api';
import { FilterAPI } from '../../api/filter-api';
import { FormAPI } from '../../api/form-api';
import { ObjectAPI } from '../../api/object-api';
import { OneUiApi } from '../../api/one-ui-api';
import { ProcessAPI } from '../../api/process-api';
import { ScriptAPI } from '../../api/script-api';
import { WorkspaceAPI } from '../../api/workspace-api';
import { ObjectListAPI } from '../../api/object-list-api';

export class OneApi {
  static restService: RestService;

  static bookmarkAPI: BookmarkAPI;
  static draftAPI: DraftAPI;
  static fileAPI: FileAPI;
  static formAPI: FormAPI;
  static objectAPI: ObjectAPI;
  static oneUiAPI: OneUiApi;
  static organizationAPI: OrganizationAPI;
  static processAPI: ProcessAPI;
  static translateAPI: TranslateAPI;
  static userAPI: UserAPI;
  static scriptAPI: ScriptAPI;
  static workspaceAPI: WorkspaceAPI;
  static userPreferencesAPI: UserPreferencesAPI;
  static filterAPI: FilterAPI;
  static objectListAPI: ObjectListAPI;

  static init(restService: RestService, enableDelegation?: boolean, disableFieldLocalizedFeedbacks?: boolean): void {
    OneApi.restService = restService;

    defineAPIs(restService);

    setAPI<DraftAPI>('draftAPI', new DraftAPI(restService, enableDelegation, disableFieldLocalizedFeedbacks));
    setAPI<FileAPI>('fileAPI', new FileAPI(restService));
    setAPI<ObjectAPI>('objectAPI', new ObjectAPI(restService, enableDelegation));
    setAPI<ProcessAPI>('processAPI', new ProcessAPI(restService, enableDelegation));
    setAPI<WorkspaceAPI>('workspaceAPI', new WorkspaceAPI(restService));
    setAPI<BookmarkAPI>('bookmarkAPI', new BookmarkAPI(restService));
    setAPI<OneUiApi>('oneUiAPI', new OneUiApi(restService));
    setAPI<FormAPI>('formAPI', new FormAPI(restService));
    setAPI<ScriptAPI>('scriptAPI', new ScriptAPI(restService));
    setAPI<FilterAPI>('filterAPI', new FilterAPI(restService));
    setAPI<ObjectListAPI>('objectListAPI', new ObjectListAPI(restService));

    // UI API's
    OneApi.organizationAPI = getAPI<OrganizationAPI>('organizationAPI');
    OneApi.translateAPI = getAPI<TranslateAPI>('translateAPI');
    OneApi.userAPI = getAPI<UserAPI>('userAPI');
    OneApi.userPreferencesAPI = getAPI<UserPreferencesAPI>('userPreferencesAPI');

    // ONE API's
    OneApi.draftAPI = getAPI<DraftAPI>('draftAPI');
    OneApi.fileAPI = getAPI<FileAPI>('fileAPI');
    OneApi.objectAPI = getAPI<ObjectAPI>('objectAPI');
    OneApi.processAPI = getAPI<ProcessAPI>('processAPI');
    OneApi.workspaceAPI = getAPI<WorkspaceAPI>('workspaceAPI');
    OneApi.bookmarkAPI = getAPI<BookmarkAPI>('bookmarkAPI');
    OneApi.oneUiAPI = getAPI<OneUiApi>('oneUiAPI');
    OneApi.formAPI = getAPI<FormAPI>('formAPI');
    OneApi.scriptAPI = getAPI<ScriptAPI>('scriptAPI');
    OneApi.filterAPI = getAPI<FilterAPI>('filterAPI');
    OneApi.objectListAPI = getAPI<ObjectListAPI>('objectListAPI');
  }

  static changeConfig(
    config: Partial<RestServiceConfig>,
    params?: Partial<RequestParams>,
    disableFieldLocalizedFeedbacks?,
  ): void {
    const restService = new DefaultRestService(config, params);
    OneApi.init(restService, true, disableFieldLocalizedFeedbacks);
  }
}
